// @ts-ignore

import {Component, EventEmitter, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExcRestService} from 'exc-rest-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {Subscription} from 'rxjs';
// @ts-ignore
import {ExgMapDistanceMatrixService} from 'exc-map-v2';
import {ExgApplicationTabService} from 'exc-tab-v2';

@Component({
  selector: 'app-disposition-map',
  templateUrl: './disposition-map.component.html',
  styles: []
})
export class DispositionMapComponent extends ExcTranslation implements OnInit, IExgEvent {

  Events = new ExgApplicationEventEmitter();
  doDistanceMatrix = true;
  miniMap: any = {
    latitude: 50,
    longitude: 9,
    zoom: 5,
    minZoom: 1,
    maxZoom: 5,
    rectangle: {
      north: 0,
      south: 0,
      east: 0,
      west: 0
    },
    click: (e: google.maps.MapMouseEvent | google.maps.IconMouseEvent) => {
      this.bigMap.latitude = e.latLng?.lat() ||  this.bigMap.latitude;
      this.bigMap.longitude = e.latLng?.lng() ||  this.bigMap.longitude;
    }
  };
  markerIcon: any = {};
  bigMap: any = {
    latitude: 50,
    longitude: 9,
    zoom: 8,
    minzoom: 6,
    boundsChange: (e: google.maps.LatLngBounds) => {
      this.miniMap.rectangle.north = e.getNorthEast().lat();
      this.miniMap.rectangle.east = e.getNorthEast().lng();
      this.miniMap.rectangle.south = e.getSouthWest().lat();
      this.miniMap.rectangle.west = e.getSouthWest().lng();
      this.miniMap.latitude = e.getCenter().lat();
      this.miniMap.longitude = e.getCenter().lng();
      this.miniMap.zoom = this.bigMap.zoom - 3; //(this.bigMap.zoom - 3 < this.miniMap.zoom) ? this.bigMap.zoom - 3 : this.miniMap.zoom;
    },
    ready: (e: any) => {
      const pinSVGHole = 'M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z';
      const pinSVGHole2 = 'M4662.9,4958.9c-36.8-36.8-51.1-71.5-51.1-132.8c0-61.3-8.2-81.7-32.7-81.7c-16.3,0-118.5-28.6-224.7-63.3l-192-65.4v-422.9c0-398.4-2-427-42.9-478.1c-55.2-69.5-175.7-75.6-234.9-10.2c-34.7,36.8-40.9,85.8-49,380l-10.2,337.1l-81.7-61.3c-465.8-337.1-817.2-943.9-862.1-1485.2l-12.3-143l-143-134.8c-136.9-130.8-143-138.9-130.8-210.4c47-290.1,582.2-547.5,1362.7-655.8c316.7-45,1350.4-63.3,1718.1-32.7c790.6,67.4,1350.4,239,1609.9,490.3c175.7,171.6,167.5,255.4-36.8,410.6l-141,108.3l-12.3,138.9c-57.2,563.9-363.6,1127.7-804.9,1475l-124.6,96l-6.1-335c-6.1-296.2-10.2-339.1-45-377.9c-59.2-65.4-179.8-59.2-234.9,10.2c-40.9,51.1-42.9,79.7-42.9,471.9v416.8l-94,38.8c-51.1,22.5-151.2,57.2-224.7,75.6l-130.8,34.7v79.7c0,55.2-14.3,91.9-51.1,126.7c-47,49-59.2,51.1-337.1,51.1C4722.2,5010,4709.9,5008,4662.9,4958.9zM2981.5,1563.5c-155.3-222.7-122.6-749.8,73.5-1140c67.4-134.8,198.2-326.9,292.1-429c47-51.1,94-134.8,122.6-214.5c269.7-788.6,952-1315.7,1626.2-1258.5c623.1,51.1,1195.1,555.7,1434.2,1258.5c28.6,79.7,75.6,163.4,122.6,214.5c89.9,98.1,222.7,292.1,288.1,418.8c175.7,345.3,228.8,845.8,112.4,1088.9c-57.2,122.6-73.5,128.7-241.1,79.7c-641.5-188-1613.9-269.7-2427.1-208.4c-388.2,30.6-905,114.4-1142,183.9c-112.4,34.7-206.3,61.3-212.5,61.3C3024.4,1618.7,3004,1594.1,2981.5,1563.5zM3320.7-947.3l-179.8-73.6V-1979v-958.2H5000h1859.1v958.2v958.1l-177.7,71.5l-179.8,73.6l-51.1-65.4c-208.4-267.6-471.9-484.2-745.7-617c-232.9-112.4-377.9-151.2-623.1-167.5c-545.5-32.7-1080.7,237-1513.8,764.1l-69.5,85.8L3320.7-947.3zM2282.8-1382.5c-606.8-271.7-913.2-506.7-1168.6-892.8C811.9-2732.9,587.2-3450,587.2-3960.7c0-200.2,6.1-208.4,173.7-277.9c126.7-53.1,445.4-155.2,623.1-200.2c73.6-18.4,149.1-36.8,167.5-42.9c30.6-8.2,34.7,34.7,40.9,506.7l6.1,518.9l67.4,134.9c122.6,251.3,314.6,363.7,641.5,380l200.2,10.2v813.1c0,639.5-6.1,815.1-24.5,815.1C2468.7-1302.8,2378.9-1339.6,2282.8-1382.5zM7492.4-2115.9v-817.2l241.1-6.1c222.7-8.2,249.3-12.3,375.9-75.6c149.1-73.6,251.3-175.7,326.9-328.9c44.9-89.9,47-120.5,53.1-608.8c4.1-284,10.2-516.9,12.3-516.9c32.7,0,492.4,141,643.5,196.1c267.6,100.1,267.6,100.1,267.6,312.6c0,422.9-155.3,997-394.3,1462.8c-169.6,328.9-443.3,633.3-735.5,823.3c-149.1,96-641.5,339.1-735.5,361.6l-55.2,14.3V-2115.9zM2221.5-4089.4v-516.9l251.3-32.7c1479.1-196.1,3487.4-202.3,4968.5-12.3c179.8,22.5,347.3,45,373.9,53.1l45,10.2v508.7v508.7H5040.9H2221.5V-4089.4z';
      const labelOriginHole = new google.maps.Point(16, 16);
      const pinSVGFilled = 'M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z';
      const labelOriginFilled = new google.maps.Point(12, 9);
      /* this.markerIcon.SO = {
         path: pinSVGHole,
         anchor: new google.maps.Point(12, 17),
         fillOpacity: 1,
         fillColor: 'red',
         strokeWeight: 2,
         strokeColor: 'white',
         scale: 2,
         labelOrigin: labelOriginHole
       };*/
      this.markerIcon.SO = {
        url: './assets/images/Small_SVG_house_icon.svg',
        scaledSize: new google.maps.Size(50, 50)
      };
      /*  this.markerIcon.DLunqualified = {
          path: pinSVGHole2,
          anchor: new google.maps.Point(12, 17),
          fillOpacity: 1,
          fillColor: 'yellow',
          strokeWeight: 2,
          strokeColor: 'white',
          scale: 1.5,
          labelOrigin: labelOriginHole
        };*/
      this.markerIcon.DLunqualified = {
        url: './assets/images/worker_yellow.svg',
        scaledSize: new google.maps.Size(32, 32),
        anchor: new google.maps.Point(16, 16),
        labelOrigin: labelOriginHole
      };
      /*this.markerIcon.DLneutral = {
        path: pinSVGHole,
        anchor: new google.maps.Point(12, 17),
        fillOpacity: 1,
        fillColor: 'blue',
        strokeWeight: 2,
        strokeColor: 'white',
        scale: 1.5,
        labelOrigin: labelOriginHole
      };*/
      this.markerIcon.DLneutral = {
        url: './assets/images/worker_blue.svg',
        scaledSize: new google.maps.Size(32, 32),
        anchor: new google.maps.Point(16, 16),
        labelOrigin: labelOriginHole
      };
    }
  };
  DispoListDefinitions: any = undefined;
  summaryData: any = {};
  heatMapData: any = [];

  markerInfo: any[] = [];
  matrixRunning = false;
  matrixRunningEventEmitter = new EventEmitter();
  matrixRunningSubscriber: Subscription = new Subscription();
  matrixTriggered = false;
  config = {
    summaryData: {
      selected: [] as any[],
      selectedObjects: [] as any[],
      /* selectionChanged: ($event: any) => {
         let mark = [...this.markerInfo];
         let matrixDestinations: { source: any, value: string, results: any[] }[] = [];
         for (let i = 0; i < this.summaryData.DL.length; i++) {
           mark[i] = this.getMarker('DL', this.summaryData.DL[i]);
           if (mark[i].visible) {
             matrixDestinations.push({
               source: this.summaryData.DL[i],
               value: this.summaryData.DL[i].adrStr + ' ' + this.summaryData.DL[i].adrHNum + ' ' + this.summaryData.DL[i].adrPlz + ' ' + this.summaryData.DL[i].adrOrt,
               results: []
             });
           }
         }
         this.markerInfo = [...mark];


         if (this.config.summaryData.selectedObjects.length > 0) {

           let origins: { source: any, value: string, results: any[] }[] = [];
           for (let i = 0; i < this.config.summaryData.selectedObjects.length; i++) {
             let adrSource: any = this.config.summaryData.selectedObjects[i];
             origins.push({
               source: this.config.summaryData.selectedObjects[i] as any,
               value: adrSource.adrStr + ' ' + adrSource.adrHNum + ' ' + adrSource.adrPlz + ' ' + adrSource.adrOrt,
               results: []
             });
           }

           if (!this.matrixRunning) {
             this.matrixRunning = true;
             this.getDistanceMatrix(origins, matrixDestinations).then((a: any) => {
               this.matrixRunning = false;
               for (let elem of origins) {
                 elem.source.destinations = elem.results;
               }
               for (let elem of matrixDestinations) {
                 elem.source.origins = elem.results;
               }
             });
           }

         }
       },*/
      rowChange: (index: number) => {
        this.config.summaryData.selectedObjects = [this.summaryData.Schadenorte[index]];
        this.bigMap.latitude = this.config.summaryData.selectedObjects[0].adrLat || 50;
        this.bigMap.longitude = this.config.summaryData.selectedObjects[0].adrLng || 9;

        let mark = [...this.markerInfo];
        let matrixDestinations: { source: any, value: string, results: any[] }[] = [];
        for (let i = 0; i < this.summaryData.DL.length; i++) {
          mark[i] = this.getMarker('DL', this.summaryData.DL[i], i);
          if (mark[i].visible) {
            matrixDestinations.push({
              source: this.summaryData.DL[i],
              value: this.summaryData.DL[i].adrStr + ' ' + this.summaryData.DL[i].adrHNum + ' ' + this.summaryData.DL[i].adrPlz + ' ' + this.summaryData.DL[i].adrOrt,
              results: []
            });
          }
        }
        this.markerInfo = [...mark];


        if (this.config.summaryData.selectedObjects.length > 0) {

          let origins: { source: any, value: string, results: any[] }[] = [];
          for (let i = 0; i < this.config.summaryData.selectedObjects.length; i++) {
            let adrSource: any = this.config.summaryData.selectedObjects[i];
            origins.push({
              source: this.config.summaryData.selectedObjects[i] as any,
              value: adrSource.adrStr + ' ' + adrSource.adrHNum + ' ' + adrSource.adrPlz + ' ' + adrSource.adrOrt,
              results: []
            });
          }

          if (!this.matrixRunning) {
            //this.matrixRunning = true;
            this.getDistanceMatrix(origins, matrixDestinations).then((a: any) => {
              this.matrixRunning = false;
              for (let elem of origins) {
                elem.source.destinations = elem.results;
              }
              for (let elem of matrixDestinations) {
                elem.source.origins = elem.results;
              }
            });
          }

        }
      }
    }
  };

  constructor(private exgApplicationTabService: ExgApplicationTabService, private excRestService: ExcRestService, public enumSvc: EnumerationService, private distanceMatrixService: ExgMapDistanceMatrixService) {
    super();
    this.registerEvents();
    this.initialize();
  }

  private registerEvents() {
    if (this.exgApplicationTabService.StateTab?.Active) {
      ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
        this.LoadData();
      });
    }
  }

  private initialize() {
  }

  getDistanceMatrix(origins: any[], destinations: any[]): Promise<any> {
    if (!this.doDistanceMatrix) {
      return new Promise(async (res, rej) => {
        res({origins, destinations});
      });
    }
    return new Promise(async (res, rej) => {
      let originChunks: any[] = [];
      let destinationChunks: any[] = [];
      for (let i = 0; i < origins.length; i = i + 10) {
        originChunks.push(origins.slice(i, i + 10));
      }
      for (let i = 0; i < destinations.length; i = i + 10) {
        destinationChunks.push(destinations.slice(i, i + 10));
      }
      for (let o = 0; o < originChunks.length; o++) {
        for (let p = 0; p < destinationChunks.length; p++) {
          let start = Date.now();
          let abc = await this.getDistanceMatrixSub(originChunks[o], destinationChunks[p]).catch((err) => {
            console.log(err);
          });
          if (origins.length * destinations.length > 100) {
            console.log(1100 - (Date.now() - start));
            await new Promise(r => setTimeout(r, 1100 - (Date.now() - start)));
          }
        }
      }
      res({origins, destinations});
    });


  }

  getDistanceMatrixSub(origins: any[], destinations: any[], retries: number = 0): Promise<any> {
    return new Promise((res, rej) => {
      //let service = new google.maps.DistanceMatrixService();
      let originChunksValueArray: string[] = origins.map(a => a.value);
      let destinationChunksValueArray: string[] = destinations.map(a => a.value);
      this.distanceMatrixService.getDistanceMatrix({
        origins: originChunksValueArray,
        destinations: destinationChunksValueArray,
        travelMode: google.maps.TravelMode.DRIVING
      }).subscribe((response: any) => {
        let originList = response.originAddresses;
        let destinationList = response.destinationAddresses;

        for (let i = 0; i < origins.length; i++) {
          let results = response.rows[i].elements;
          for (let j = 0; j < results.length; j++) {
            try {

              let element = results[j];
              let distance = element.distance.text;
              let duration = element.duration.text;
              let from = originList[i];
              let to = destinationList[j];
              origins[i].results.push({source: destinations[j].source, result: {distance, duration, from, to}});
              destinations[j].results.push({source: origins[i].source, result: {distance, duration, from, to}});
            } catch {
              origins[i].results.push({
                source: destinations[j].source,
                result: {distance: 'NaN', duration: 'NaN', from: 'not found', to: 'not found'}
              });
              destinations[j].results.push({
                source: origins[i].source,
                result: {distance: 'NaN', duration: 'NaN', from: 'not found', to: 'not found'}
              });
            }
            res({origins, destinations});

          }
        }
      }, (error: any) => {
        if (retries < 3) {
          retries++;
          const prom = new Promise<any>(async (e: any) => {
            setTimeout(async () => {
              return await this.getDistanceMatrixSub(origins, destinations, retries);
            }, 1000 * retries);
          }).then(x => {
            return x;
          });
          return  prom;

        } else {
          return new Promise<any>(e => {
          });
        }
      });
    });
  }

  getMarker = (type: string, marker?: any, index?: any): any => {
    let test = this.applyDispositionListDefinition(marker);
    let existingMarkerInfo = this.markerInfo[index];
    return {
      marker: this.markerIcon[type + test.mode],
      visible: test.visible,
      messages: test.messages,
      isOpen: (!existingMarkerInfo) ? false : ((test.visible) ? existingMarkerInfo.isOpen : false)
    };
  };

  loadDispoListDefinitions(DBResult: any) {
    if (!this.DispoListDefinitions) {
      this.DispoListDefinitions = {} as any;
      for (const row of DBResult) {
        this.DispoListDefinitions[row.ldefListDefinitionType] = {} as any;
        for (const typeRow of row.Types) {
          this.DispoListDefinitions[row.ldefListDefinitionType][typeRow.ldefFieldName] = {
            ldefEntity: typeRow.ldefEntity,
            ldefExclude: typeRow.ldefExclude,
            Values: typeRow.Values
          } as any;
          for (const valueRow of typeRow.Values) {
            valueRow.lvalValue = JSON.parse(valueRow.lvalValue);
          }
        }
      }
    }
  }

  applyDispositionListDefinition(marker: any): { visible: boolean, mode: string, messages: any[] } {
    let rtVal = {visible: true, mode: 'neutral', messages: [] as any[]};
    if (this.config.summaryData.selectedObjects.length > 0) {
      for (const [k, v] of Object.entries(this.DispoListDefinitions)) {
        for (const [kItem, vItem] of Object.entries(v as any)) {
          const index = (vItem as any).Values.findIndex((e: any) => {
            const matchOE = e.lval_FK.toUpperCase() === marker.oeID.toUpperCase();
            if (matchOE) {
              return e.lvalValue.findIndex((o: any) => {
                return this.config.summaryData.selectedObjects[0][kItem].toString().toUpperCase() === o.toUpperCase();
              }) > -1;
            }
            return false;
          });
          if ((k === 'BLACKLIST' && index > -1) || (k === 'WHITELIST' && index === -1)) {
            rtVal.visible = rtVal.visible && !(vItem as any).ldefExclude;
            rtVal.mode = 'unqualified';
            rtVal.messages.push(ExcCoreModule.String.Format('{0}: {1}', k, this.enumSvc.getFieldCaption((vItem as any).ldefEntity, kItem)));
          }
        }
      }
    }
    return rtVal;
  };


  ngOnInit(): void {
    this.LoadData();
  }

  LoadData(): void {
    this.excRestService.get(this.excRestService.computeUrl('DispositionR_Summary', {loadListDefinitions: !this.DispoListDefinitions})).subscribe((result) => {

      this.loadDispoListDefinitions(result.data.DispositionListDefinitionValues);
      for (let i = 0; i < result.data.DL.length; i++) {
        this.markerInfo.push(this.getMarker('DL', result.data.DL[i], i));
      }
      this.summaryData = result.data;
      const hmData = [];
      for (let i = 0; i < result.data.SOHeatmap.length; i++) {
        hmData.push(new google.maps.LatLng({lat: result.data.SOHeatmap[i].adrLat, lng: result.data.SOHeatmap[i].adrLng}));
      }
      this.heatMapData = hmData;
    });
  }


  assign(marker: any) {
    this.config.summaryData.selectedObjects.map((e: any) => {
      e.marker = marker;
    });

    this.config.summaryData.selectedObjects = [];
    this.config.summaryData.selected = [];

  }
}
